/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const CCb = require('./CCb')
const CCbGlob = require('../kernel/CCbGlob')
const CConstante = require('./CConstante')
const CMoinsUnaire = require('./CMoinsUnaire')
module.exports = CResultatValeur

/**
 * Classe repésentant dans un arbre binaire le résultat d'un calcul ou d'une mesure réelle existant.
 * @constructor
 * @extends CCb
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CValDyn} valeurAssociee : La valeur dont c'est le résultat.
 * @returns {CResultatValeur}
 */
function CResultatValeur (listeProprietaire, valeurAssociee) {
  if (arguments.length === 0) return // Ajout version WebPack
  CCb.call(this, listeProprietaire);
  if (arguments.length !== 1) this.valeurAssociee = valeurAssociee;
}
CResultatValeur.prototype = new CCb();
CResultatValeur.prototype.constructor = CResultatValeur;
CResultatValeur.prototype.superClass = "CCb";
CResultatValeur.prototype.className = "CResultatValeur";

CResultatValeur.prototype.nature = function() {
  return CCbGlob.natResultatValeur;
};
CResultatValeur.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.valeurAssociee);
  return new CResultatValeur(listeCible, listeCible.get(ind1, "CValDyn"));
};
CResultatValeur.prototype.existe = function(infoRandom) {
  return this.valeurAssociee.existe;
};
CResultatValeur.prototype.resultat = function(infoRandom) {
  return this.valeurAssociee.rendValeur(infoRandom);
};
CResultatValeur.prototype.depDe = function(p) {
    if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memDep(CCb.prototype.depDe.call(this,p) ||
    this.valeurAssociee.depDe(p));
};
CResultatValeur.prototype.dependDePourBoucle = function(p) {
  return this.valeurAssociee.dependDePourBoucle(p);
};
CResultatValeur.prototype.dependDeVariable = function(ind) {
  return false;
};
CResultatValeur.prototype.getCopie = function() {
  return new CResultatValeur(this.listeProprietaire, this.valeurAssociee);
};
CResultatValeur.prototype.chaineCalcul = function() {
  return this.valeurAssociee.getNom();
};
CResultatValeur.prototype.chaineLatex = function() {
  if (this.valeurAssociee.getNom() === "pi") return "\\pi "; // Espace à la fin nécesssaire
  else return this.valeurAssociee.getNom();
};
CResultatValeur.prototype.read = function(inps, list){
  CCb.prototype.read.call(this, inps, list);
  var ind1 = inps.readInt();
  this.valeurAssociee = list.get(ind1,"CValDyn");
};
CResultatValeur.prototype.write = function(oups, list){
  CCb.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.valeurAssociee);
  oups.writeInt(ind1);
};

CResultatValeur.prototype.estConstant = function() {
 return this.valeurAssociee.className === "CCalcConst";
};

CResultatValeur.prototype.calculAvecValeursRemplacees = function() {
  var d = this.valeurAssociee.rendValeur(false);
  if (d < 0) return new CMoinsUnaire(this.listeProprietaire, new CConstante(this.listeProprietaire, -d));
  else return new CConstante(this.listeProprietaire, d);
};
CResultatValeur.membreGauche = function() {
  return this.valeurAssociee.membreGauche();
};
CResultatValeur.membreDroit = function() {
  return this.valeurAssociee.membreDroit();
};
